import type { TourStep } from "../tour-steps";
import { CONFIGURACOES, MINHA_CLINICA, ajudaFinal, area, boasVindas } from "./passos";

/** Clínica: do dia a dia (paciente → consulta → plano → prótese) pra gestão. */
export const tourDaClinica = (c: boolean): TourStep[] => [
  boasVindas(
    "Bem-vindo à sua clínica no DentalBook",
    "Em um minuto você vê onde fica cada parte do dia a dia: pacientes, agenda, plano de tratamento, prótese e a gestão da clínica.",
  ),
  area(c, {
    id: "inicio",
    menu: "sidebar-inicio",
    aba: "aba-inicio",
    nome: "Início",
    titulo: "Seu dia começa aqui",
    texto: "O Início mostra as consultas e os pedidos de prótese do período, com atalhos para Pacientes, Agendar consulta e Pedir prótese.",
  }),
  area(c, {
    id: "pacientes",
    menu: "sidebar-pacientes",
    aba: "aba-pacientes",
    nome: "Pacientes",
    titulo: "Pacientes e a ficha de cada um",
    texto: "Cadastre o paciente (nome e telefone bastam) ou mande um link para ele mesmo se cadastrar. A ficha reúne dados, anamnese, odontograma, plano de tratamento, consultas, próteses, arquivos e histórico.",
  }),
  area(c, {
    id: "agenda",
    menu: "sidebar-agenda",
    aba: "aba-agenda",
    nome: "Agenda",
    titulo: "Agenda da clínica",
    texto: "Marque consultas por dia, semana, quinzena ou mês, filtre por profissional e acompanhe o status de cada atendimento — de agendado a atendido.",
  }),
  area(c, {
    id: "plano",
    menu: "sidebar-pacientes",
    aba: "aba-pacientes",
    nome: "Pacientes",
    titulo: "Plano de tratamento",
    texto: "Dentro da ficha do paciente, a aba Tratamentos monta o plano dente a dente (ou no modo Face), com preços do seu catálogo, impressão do orçamento e acompanhamento do que já foi feito.",
  }),
  area(c, {
    id: "protese",
    menu: "sidebar-protese",
    nome: "Prótese",
    titulo: "Pedidos de prótese",
    texto: "Peça trabalhos aos laboratórios parceiros e acompanhe prazo e status de cada pedido, sem telefone nem WhatsApp. Laboratórios novos você conecta por convite.",
  }),
  area(c, {
    id: "procedimentos",
    menu: "sidebar-procedimentos",
    nome: "Procedimentos",
    titulo: "Procedimentos e preços",
    texto: "O catálogo da clínica: duração, cor na agenda e preço de cada procedimento. É dele que saem os valores do plano de tratamento.",
  }),
  area(c, {
    id: "arquivos",
    menu: "sidebar-arquivos-clinica",
    nome: "Arquivos",
    titulo: "Arquivos da clínica",
    texto: "Radiografias, fotos e documentos em pastas, ligados ao paciente ou ao pedido, e compartilhados com quem precisa.",
  }),
  MINHA_CLINICA(c),
  CONFIGURACOES(c),
  ajudaFinal(),
];
